import React from 'react';
import { AuthenticationHandler } from '@dentalux/security';
const unprotectedRoutes = {
  // legals
  '/terms': true,
  '/information': true,
  '/privacy': true,
  '/joint-controllership': true,
  // auth
  '/registration': true,
  '/login': true,
  '/login/[token]': true,
  '/verifyphone': true,
  '/verifyphone/[token]': true,
  '/verifyemail': true,
  '/verifyemail/[token]': true,
  '/registration/[token]': true,
  '/forgot-password': true,
  '/reset-password/[token]': true,
  '/reset-phone-number/[token]': true,
  // other
  '/contact': true,
  '/farewell': true
};
const RouteGuard = ({
  children,
  path
}) => {
  if (unprotectedRoutes[path]) return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  return /*#__PURE__*/React.createElement(AuthenticationHandler, null, children);
};
export default RouteGuard;